<template>
  <div>
    <MglGeojsonLayer
      :sourceId="getBestTceGeoJson.data.id"
      :source="getBestTceGeoJson"
      :layerId="getBestTceLineLayer.id"
      :layer="getBestTceLineLayer"
    />
    <MglGeojsonLayer
      :sourceId="getBestTceGeoJson.data.id"
      :source="getBestTceGeoJson"
      :layerId="getBestTcePointsLayer.id"
      :layer="getBestTcePointsLayer"
    />
  </div>
</template>
        
        <script>
import { MglGeojsonLayer } from "vue-mapbox";
import { mapGetters } from "vuex";

export default {
  name: "BestTceLayer",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/voyageDetailsModule", ["getBestTceGeoJson"]),
    ...mapGetters("weatherRouting/weatherRoutingMapModule", [
      "getBestTceLineLayer",
      "getBestTcePointsLayer",
    ]),
  },
};
</script>